var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1171 3.20362L8.36564 1.02288C8.27397 0.993279 8.17621 0.992385 8.0841 1.02029L5.43879 1.82182L12.7447 4.32614V8.22182C12.7447 8.36213 12.6548 8.48484 12.5258 8.52045L9.81478 9.2689C9.72681 9.29319 9.63314 9.27315 9.56113 9.2147C9.48912 9.15624 9.44696 9.06596 9.44696 8.97026V5.21626H9.44397L2.3085 2.77033L0.93547 3.18635C0.850069 3.19705 0.76754 3.23038 0.696934 3.28624C0.582998 3.37646 0.51292 3.51375 0.502168 3.66208C0.501582 3.66887 0.501377 3.67577 0.501025 3.68262C0.50082 3.68897 0.5 3.69523 0.5 3.70161V12.4887C0.5 12.7203 0.645547 12.9239 0.856925 12.9881L7.3266 14.9527C7.42928 15.0021 7.54339 15.0131 7.65244 14.9842L15.1269 13.0006C15.3463 12.9424 15.5 12.7347 15.5 12.4967V3.70954C15.5 3.47204 15.3461 3.25917 15.1171 3.20362Z",
    fill: "#CCCFD1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBox);
export default __webpack_public_path__ + "static/media/icon-box.755838df162ef70d6d2817a206930136.svg";
export { ForwardRef as ReactComponent };